import { render, staticRenderFns } from "./HomesByOwner.vue?vue&type=template&id=1d1a1e7a&scoped=true"
import script from "./HomesByOwner.vue?vue&type=script&lang=js"
export * from "./HomesByOwner.vue?vue&type=script&lang=js"
import style0 from "./HomesByOwner.vue?vue&type=style&index=0&id=1d1a1e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a1e7a",
  null
  
)

export default component.exports